<script lang="ts" setup>
import { BrandsProps } from "~/components/Filters/Utils/Modals/Brands.props"
import { BRANDS_MODAL } from "~/utils/filters"

const props = defineProps<BrandsProps>()
const emit =
  defineEmits<{
    (e: "onClose"): void
    (e: "onSelectAll"): void
    (e: "onDeleteAll"): void
    (e: "onApply"): void
  }>()
</script>

<template>
  <FiltersUtilsModalsOptions
    :facet-name="'brand.name'"
    id-facet="brand.name"
    :name="BRANDS_MODAL"
    :title="$t('filters.utils.common.brands')"
    :search-item="$t('filters.utils.modals.brands.brand')"
    :primary-action="props.primaryAction"
    @onClose="emit('onClose')"
    @onSelectAll="emit('onSelectAll')"
    @onDeleteAll="emit('onDeleteAll')"
    @onApply="emit('onApply')"
  />
</template>
